import { render, staticRenderFns } from "./TreeModel.vue?vue&type=template&id=00b17ed6&scoped=true"
import script from "./TreeModel.vue?vue&type=script&lang=js"
export * from "./TreeModel.vue?vue&type=script&lang=js"
import style0 from "./TreeModel.vue?vue&type=style&index=0&id=00b17ed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b17ed6",
  null
  
)

export default component.exports